<script setup>
import { computed } from 'vue'
import { usePage, router } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const page = usePage()
const flash = computed(() => page.props.flash || {})
const currentLocale = computed(() => page.props.locale || 'en')
const { t } = useI18n()

function setLang(lang) {
  if (lang === currentLocale.value) return
  router.get(window.location.pathname, { lang }, { preserveScroll: true, preserveState: false })
}
</script>

<template>
  <div class="auth-shell">
    <div v-if="flash.alert" class="auth-flash auth-flash--alert" role="alert">{{ flash.alert }}</div>
    <div v-if="flash.notice" class="auth-flash auth-flash--notice">{{ flash.notice }}</div>
    <main class="auth-card">
      <header class="auth-card__brand">
        <span>{{ t('driver_portal.brand.name') }} <span class="auth-card__sub">· {{ t('driver_portal.brand.sub') }}</span></span>
        <div class="auth-lang">
          <button :class="['auth-lang__btn', currentLocale === 'en' && 'is-active']" type="button" @click="setLang('en')">EN</button>
          <span class="auth-lang__sep">·</span>
          <button :class="['auth-lang__btn', currentLocale === 'ru' && 'is-active']" type="button" @click="setLang('ru')">RU</button>
        </div>
      </header>
      <slot />
    </main>
  </div>
</template>

<style scoped>
.auth-shell {
  min-height: 100vh;
  display: grid;
  place-items: center;
  background: color-mix(in oklch, var(--accent) 6%, var(--bg));
  padding: max(env(safe-area-inset-top), 1rem);
}
.auth-card {
  width: 100%; max-width: 24rem;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--radius-lg, 12px);
  padding: 1.75rem 1.5rem 1.5rem;
  box-shadow: 0 10px 25px -10px color-mix(in oklch, var(--accent) 25%, transparent);
}
.auth-card__brand {
  display: flex; align-items: center; justify-content: space-between; gap: 1rem;
  font-family: var(--font-display, var(--display));
  font-size: 1.125rem; font-weight: 700; color: var(--ink);
  margin-bottom: 1.25rem; letter-spacing: 0.01em;
}
.auth-card__sub { color: var(--muted); font-weight: 500; }
.auth-lang { display: flex; align-items: center; gap: 0.25rem; }
.auth-lang__btn {
  background: transparent; border: 0; color: var(--muted);
  font-size: 0.75rem; font-weight: 600; cursor: pointer; padding: 0.1rem 0.2rem;
  letter-spacing: 0.03em;
}
.auth-lang__btn.is-active { color: var(--accent); }
.auth-lang__sep { color: var(--line); font-size: 0.75rem; }
.auth-flash {
  width: 100%; max-width: 24rem;
  padding: 0.75rem 1rem; margin-bottom: 0.75rem;
  border-radius: 0.5rem; font-size: 0.9375rem;
}
.auth-flash--alert {
  background: color-mix(in oklch, var(--danger) 12%, var(--surface));
  color: var(--danger);
}
.auth-flash--notice {
  background: color-mix(in oklch, var(--ok) 12%, var(--surface));
  color: var(--ok);
}
</style>
